import { render, staticRenderFns } from "./products-picker.vue?vue&type=template&id=b904453a&scoped=true&"
import script from "./products-picker.vue?vue&type=script&lang=js&"
export * from "./products-picker.vue?vue&type=script&lang=js&"
import style0 from "./products-picker.vue?vue&type=style&index=0&id=b904453a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b904453a",
  null
  
)

export default component.exports